import { Id, Tag } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";
import { LinkedTask } from "../linkers/types";

function addTagToMilestone(httpClient: HttpClient) {
  return (tag: Tag, milestoneId: Id) =>
    httpClient
      .sendHttpRequest<LinkedTask>({
        endpoint: `/milestones/${milestoneId}`,
        method: HttpMethods.GET,
      })
      .then((milestone) =>
        httpClient.sendHttpRequest<void>({
          endpoint: `/milestones/${milestoneId}`,
          method: HttpMethods.PATCH,
          data: { tags: [...milestone.tags, tag.name] },
        }),
      );
}

export { addTagToMilestone };
